import axiosInstance from '@/libs/axios'
import { sorting } from '@/mixins'
import { storePagination } from '@/mixins/store'
import installmentPolicyMaintain from './installment-policy-maintain'

const getInitialState = () => ({
  ...storePagination.state(),
  policies: [],
  filters: { name: '', storeId: null, priceTableId: null, acquirerCostConfigId: null, status: '' },
})

export default {
  namespaced: true,
  state: getInitialState(),

  modules: { installmentPolicyMaintain },

  mutations: {
    ...storePagination.mutations,

    SET_POLICIES(state, policies) {
      state.policies = policies
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
    },
    CLEAN_STATE(state) {
      const { filters, paging, policies } = getInitialState()
      state.filters = filters
      state.paging = paging
      state.policies = policies
    },
  },

  actions: {
    ...storePagination.actions,

    /**
     * O filtro por loja e por tabela de preço traz também as políticas de escopo vazio, que
     * alcançam todas — é a mesma semântica da resolução, e sem isso o usuário concluiria que não há
     * política aplicável àquela loja quando na verdade a Geral a cobre.
     */
    async fetchPolicies({ commit, state }) {
      const { data } = await axiosInstance.get('/api/settings/financial/installment-policies', {
        params: {
          name: state.filters.name,
          storeId: state.filters.storeId,
          priceTableId: state.filters.priceTableId,
          acquirerCostConfigId: state.filters.acquirerCostConfigId,
          active: state.filters.status,
          pageSize: state.paging.pageSize,
          pageIndex: state.paging.currentPage - 1,
          sortBy: sorting.methods.getSorting(state),
        },
      })

      commit('SET_POLICIES', data.results || [])
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount || 0,
        rowsInCurrentPage: data.rowsInCurrentPage || 0,
      })
    },

    async activatePolicy(_, id) {
      await axiosInstance.patch(`/api/settings/financial/installment-policies/${id}/activate`)
    },

    async deactivatePolicy(_, id) {
      await axiosInstance.patch(`/api/settings/financial/installment-policies/${id}/deactivate`)
    },

    async duplicatePolicy(_, { id, name }) {
      await axiosInstance.post(`/api/settings/financial/installment-policies/${id}/duplicate`, name)
    },

    async deletePolicy(_, id) {
      await axiosInstance.delete(`/api/settings/financial/installment-policies/${id}`)
    },

    setFilters({ commit }, filters) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTERS', filters)
    },

    resetFilters({ commit }) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTERS', getInitialState().filters)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
